import { Conn_Db_Obj_Lnk } from '../conn_Db_Obj_Lnk';
import { DxFlow_Obj_Property } from './dxflow_obj_property';
import { RepConn } from '../datapoint/repconn';
import { CommonEnums } from 'src/app/shared/common.enums';
import { DCmd_Inst } from './dcmd_inst';
import { DxFlow_Obj_PropertiesUtil } from 'src/app/shared/utils/dxflow_obj_properties.util';

export class DBCommand {
    dCmd_Inst: DCmd_Inst;
    conn_Db_Obj_Lnk: Conn_Db_Obj_Lnk;
    conn_Db_Obj_Lnk_Ext: Conn_Db_Obj_Lnk;
    dxFlow_Obj_Properties: Array<DxFlow_Obj_Property>;
    change_Ind: string;
    error_Cd: string;
    error_Msg: string;
    ref_Id: number;
    ref_Cd: string;
    fldr_Id: number;
    repConn: RepConn;

    constructor() {
        this.setDefault();
    }

    setDefault(): void {
        this.dCmd_Inst = new DCmd_Inst();
        this.conn_Db_Obj_Lnk = new Conn_Db_Obj_Lnk();
        this.conn_Db_Obj_Lnk_Ext = new Conn_Db_Obj_Lnk();
        this.dxFlow_Obj_Properties = new Array<DxFlow_Obj_Property>();
        this.change_Ind = CommonEnums.change_Ind.NO_CHANGE;
        this.error_Cd = CommonEnums.defaults.SUCCESS_CODE;
        this.error_Msg = CommonEnums.defaults.SUCCESS_MSG;
        this.ref_Id = CommonEnums.defaults.LONG_VAL;
        this.ref_Cd = CommonEnums.defaults.STRING_EMPTY;
        this.fldr_Id = CommonEnums.defaults.DEFAULT_INT_VAL;
        this.repConn = new RepConn();
    }

    static parse(dBCommandTmp: DBCommand): DBCommand {
        let dBCommand: DBCommand = new DBCommand();
        dBCommand.copyFrom(dBCommandTmp);
        return dBCommand;
    }

    copy(): DBCommand {
        let dBCommandTmp: DBCommand = new DBCommand();

        dBCommandTmp.dCmd_Inst = this.dCmd_Inst.copy();
        dBCommandTmp.conn_Db_Obj_Lnk = this.conn_Db_Obj_Lnk.copy();
        dBCommandTmp.conn_Db_Obj_Lnk_Ext = this.conn_Db_Obj_Lnk_Ext.copy();
        dBCommandTmp.dxFlow_Obj_Properties = DxFlow_Obj_PropertiesUtil.getInstance().copy(this.dxFlow_Obj_Properties);
        dBCommandTmp.change_Ind = this.change_Ind;
        dBCommandTmp.error_Cd = this.error_Cd;
        dBCommandTmp.error_Msg = this.error_Msg;
        dBCommandTmp.ref_Id = this.ref_Id;
        dBCommandTmp.ref_Cd = this.ref_Cd;
        dBCommandTmp.fldr_Id = this.fldr_Id;
        dBCommandTmp.repConn = this.repConn.copy();

        return dBCommandTmp;
    }

    copyFrom(dBCommandTmp: DBCommand): void {
        this.dCmd_Inst.copyFrom(dBCommandTmp.dCmd_Inst);
        this.conn_Db_Obj_Lnk.copyFrom(dBCommandTmp.conn_Db_Obj_Lnk);
        this.conn_Db_Obj_Lnk_Ext.copyFrom(dBCommandTmp.conn_Db_Obj_Lnk_Ext);
        DxFlow_Obj_PropertiesUtil.getInstance().copyFrom(this.dxFlow_Obj_Properties, dBCommandTmp.dxFlow_Obj_Properties);
        this.change_Ind = dBCommandTmp.change_Ind;
        this.error_Cd = dBCommandTmp.error_Cd;
        this.error_Msg = dBCommandTmp.error_Msg;
        this.ref_Id = dBCommandTmp.ref_Id;
        this.ref_Cd = dBCommandTmp.ref_Cd;
        this.fldr_Id = dBCommandTmp.fldr_Id;
        if (dBCommandTmp.repConn)
            this.repConn = RepConn.parse(dBCommandTmp.repConn);

    }

    compare(dBCommandTmp: DBCommand): string {
        let diffString = '';
        diffString = (this.dCmd_Inst).compare(dBCommandTmp.dCmd_Inst);
        if (diffString != '') return diffString;

        diffString = this.conn_Db_Obj_Lnk.compare(dBCommandTmp.conn_Db_Obj_Lnk);
        if (diffString != '') return diffString;

        diffString = this.conn_Db_Obj_Lnk_Ext.compare(dBCommandTmp.conn_Db_Obj_Lnk_Ext);
        if (diffString != '') return diffString;

        diffString = DxFlow_Obj_PropertiesUtil.getInstance().compare(this.dxFlow_Obj_Properties, dBCommandTmp.dxFlow_Obj_Properties);
        if (diffString != '') return diffString;

        return diffString;
    }

    toString(isNotCompare: boolean = true): string {
        let str: string = "DBCommand [dCmd_Inst=" + this.dCmd_Inst.toString() +
            ", conn_Db_Obj_Lnk=" + this.conn_Db_Obj_Lnk.toString() +
            ", conn_Db_Obj_Lnk_Ext=" + this.conn_Db_Obj_Lnk_Ext.toString() +
            ", dxFlow_Obj_Properties=" + DxFlow_Obj_PropertiesUtil.getInstance().toString(this.dxFlow_Obj_Properties);

        if (isNotCompare) {
            str += ", change_Ind=" + this.change_Ind + ", error_Cd=" + this.error_Cd +
                ", error_Msg=" + this.error_Msg + ", ref_Id=" + this.ref_Id +
                ", ref_Cd=" + this.ref_Cd + ", fldr_Id=" + this.fldr_Id + ", repConn=" + this.repConn;
        }

        str += "]";
        return str;
    }
}